
<aside class="modal" [class.is_active]="isActive">
  @if (hasOverlay) {
<div class="modal-overlay" (click)="handleOverlayClick()"></div>
}
  <div class="modal-container" [class.modal-lg]="isLarge"  [class.modal-xl]="isXLarge">
    <ng-content></ng-content>
  </div>
</aside>
